import AppModalContainer from '@nxsys/components/AppModalContainer';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import React, { useRef, useState } from 'react';
import VehicleForm, { VehicleFormRef, VehicleFormValues } from './VehicleForm';
import { IBIK } from '@nxsys/types/models/BIK';
import {
  defaultCO2EmissionsOptions,
  defaultVehicleTypeOptions,
} from '@nxsys/constants/AppConstants';

type EditVehicleProps = {
  isOpen: boolean;
  toggle: () => void;
  onSubmit: (values: VehicleFormValues) => Promise<void>;
  data: IBIK;
};

const EditVehicleModal: React.FC<EditVehicleProps> = ({
  isOpen,
  toggle,
  onSubmit,
  data,
}: EditVehicleProps) => {
  const { messages } = useTypedIntl();

  const formRef = useRef<VehicleFormRef>(null);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (values: VehicleFormValues) => {
    try {
      setIsSubmitting(true);
      await onSubmit(values);
    } catch (error) {
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AppModalContainer
      title={messages['common.editVehicle']}
      isOpen={isOpen}
      toggle={toggle}
      actions={[
        {
          name: messages['common.cancel'],
          variant: 'outlined',
          onClick: toggle,
        },
        {
          name: messages['common.save'],
          buttonType: 'primary',
          onClick: () => formRef.current?.submit(),
          loading: isSubmitting,
          disabled: isSubmitting,
        },
      ]}
    >
      <VehicleForm
        formRef={formRef}
        onSubmit={handleSubmit}
        defaultValues={{
          value: data.value?.toString(),
          startDate: data.startDate,
          co2Emissions:
            defaultCO2EmissionsOptions.find(
              (option) => option.value === data.co2Emissions,
            ) || null,
          originalMarketValue: data.originalMarketValue?.toString(),
          type:
            defaultVehicleTypeOptions.find(
              (option) => option.value === data.type,
            ) || null,
          description: data.description,
          endDate: data.endDate,
          totalKilometres: data.totalKilometres?.toString(),
          eeContribution: data.eeContribution?.toString(),
          totalEeContribution: data.totalEeContribution?.toString(),
        }}
      />
    </AppModalContainer>
  );
};

export default EditVehicleModal;
